import { SpaceVisibilitySection } from '../../PersonaFormSections';
import { useCreatePersonaFormContext } from '../hooks/useCreatePersonaFormContext';

/**
 * Space visibility is one shared section rather than a persona-form one: the
 * same block serves the edit form and other surfaces, and its own migration to
 * Tessra is a change with a wider blast radius than this flag covers.
 */
export function SpaceVisibilityStepV2() {
  const form = useCreatePersonaFormContext();

  return <SpaceVisibilitySection disabled={form.formState.isSubmitting} />;
}

SpaceVisibilityStepV2.displayName = 'SpaceVisibilityStepV2';
